<template>
    <div class="panel-body bank-accounting-items-relation-settings">
        <el-table v-loading="isLoading" :data="datas" style="width: 100%" class="ah-el-data-table currency-table" empty-text="沒有資料">
            <el-table-column type="index" label="#"></el-table-column>
            <el-table-column prop="tpc" label="帳戶簡稱" width="250">
                <template slot-scope="scope">
                    <div class="strong">
                        <span v-if="scope.row.isBorrower" class="borrow-label"> 借款戶 </span>
                        <span>{{ scope.row.tpc }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="tpc" label="銀行 / 帳號" width="230">
                <template slot-scope="scope">
                    <template v-if="scope.row.sno && scope.row.bnK_BOO_NAM !== '' && scope.row.bnK_DOO_NAM !== ''">
                        <div>{{ scope.row.bnK_DOO_NAM }}</div>
                    </template>
                    <template v-else-if="scope.row.sno">
                        <div>暫存戶</div>
                    </template>
                </template>
            </el-table-column>
            <el-table-column prop="bnK_NAM" label="存摺戶名" width="150"> </el-table-column>
            <el-table-column prop="cny" label="幣別" width="60" align="right"> </el-table-column>
            <el-table-column prop="accno" label="對應會計科目">
                <template slot-scope="scope">
                    <ah-select-accounting-setting
                        v-model="scope.row.accno"
                        :allowedItems="scope.row.typ === 0 ? ['1105', '1110', '1111', '1112', '1113', '1114', '1115'] : []"
                        :allowedGroups="['assetsSettings']"
                        style="width: 220px"
                        @change="onAccoChange($event, scope.row)"
                    />
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import ahSelectAccountingSetting from '@/components/ui/ahSelectAccountingSetting.vue';

export default {
    components: { ahSelectAccountingSetting },
    data() {
        return {
            isLoading: false,
            datas: [],
        };
    },
    mounted() {
        this.updateData();
    },
    methods: {
        async updateData() {
            try {
                this.isLoading = true;
                const resp = await this.$api({
                    url: 'AccountingSettingPage/GetDepositCompareSettings',
                    method: 'GET',
                    params: { PageSize: 1000, PageNum: 1 },
                });
                this.datas = resp.data.settings.filter((item) => !item.isBorrower);
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },
        async onAccoChange($event, row) {
            const url = !row.sno ? 'UpdatePettyMoneyAccno' : 'UpdateBankAccountAccno';
            const sno = row.sno ? row.sno : undefined;

            try {
                await this.$api({
                    url: `/AccountingSettingPage/${url}`,
                    method: 'POST',
                    data: { sno, accno: $event.accno },
                });

                this.$message({ type: 'success', message: `已儲存 ${$event.accno} - ${$event.accnam}`, duration: 1000 });
            } catch (ex) {
                console.log('error', ex);
                this.$message.error('儲存失敗');
                // eslint-disable-next-line no-param-reassign
                row.accsno = null;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.bank-accounting-items-relation-settings {
    .borrow-label {
        background-color: #f95a7e;
        color: #fff;
        padding: 2px 5px;
        font-weight: bold;
        font-size: 9pt;
        border-radius: 5px;
        margin-right: 7px;
    }
}
</style>
